import {rpAppPath} from "@pg-mono/rp-routes";

import {IRcnAddressKey} from "../types/IRcnAddress";

export const parsePricesAddressPath = (pathname: string): IRcnAddressKey | null => {
    const prefix = rpAppPath.prices.flats.base;
    if (!pathname.startsWith(prefix) || !pathname.endsWith("/")) {
        return null;
    }
    // Use the raw pathname: routers may already have decoded %2D inside match.params.
    const parts = pathname.slice(prefix.length, -1).split("-");
    if (parts.length !== 3 || parts.some((part) => part.includes("/"))) {
        return null;
    }
    try {
        const [city, street, number] = parts.map((part) => decodeURIComponent(part));
        if (
            [city, street, number].some(
                (part) => !part.trim() || [...part].some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)
            )
        ) {
            return null;
        }
        return {city, street, number};
    } catch {
        return null;
    }
};
import {rpAppPath} from "@pg-mono/rp-routes";

import {IRcnAddressKey} from "../types/IRcnAddress";

export const parsePricesAddressPath = (pathname: string): IRcnAddressKey | null => {
    const prefix = rpAppPath.prices.flats.base;
    if (!pathname.startsWith(prefix) || !pathname.endsWith("/")) {
        return null;
    }
    // Use the raw pathname: routers may already have decoded %2D inside match.params.
    const parts = pathname.slice(prefix.length, -1).split("-");
    if (parts.length !== 3 || parts.some((part) => part.includes("/"))) {
        return null;
    }
    try {
        const [city, street, number] = parts.map((part) => decodeURIComponent(part));
        if (
            [city, street, number].some(
                (part) => !part.trim() || [...part].some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)
            )
        ) {
            return null;
        }
        return {city, street, number};
    } catch {
        return null;
    }
};
